export default __webpack_public_path__ + "static/media/rsof_light-logo.ed74ad99.svg";